import type { SelectOption } from '@/features/editMode/types/selectOption';
import { useMemo } from 'react';
import { EdsSelectPropertyNames } from '@/features/eds/enums/EdsSelectPropertyNames';
import { edsToCodeFormat } from '@/features/eds/services/utils/edsToCodeFormat';
import { useFetch } from '@/hooks/useFetch';
import CacheService from '@/services/CacheService/CacheService';

const fetchConfig = {
  config: { baseURL: import.meta.env.VITE_API_URL_EDS },
};

export const useFetchEDSSelectOptions = <T extends EdsSelectPropertyNames>(
  entityName: string,
  propertyNames: T,
  skip?: boolean,
) => {
  const { data, isLoading, refetch } = useFetch<Record<T, SelectOption[]>>(
    `options/${entityName}/${propertyNames}`,
    fetchConfig,
    skip,
    { timeMs: CacheService.minutes(0.5), dependencies: [entityName, propertyNames] },
  );

  const normalizedData = useMemo(
    () =>
      (data?.[propertyNames] || data?.[edsToCodeFormat(propertyNames)] || []).filter(
        (option) => option.metadata?.disabled !== true,
      ),
    [data, propertyNames],
  );

  return { data: normalizedData, isLoading, refetch };
};
